import { render } from "./HomeHeroSlider.vue?vue&type=template&id=24a08286&scoped=true"
import script from "./HomeHeroSlider.vue?vue&type=script&lang=js"
export * from "./HomeHeroSlider.vue?vue&type=script&lang=js"

import "./HomeHeroSlider.vue?vue&type=style&index=0&id=24a08286&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a08286"]])

export default __exports__